<template lang="pug">
    section#depoimentos
        .galleryContainer
            ul#galeria
                li.item(v-for="item, index in items" :class="{'ativo' : index == ativo}")
                    .image
                        img(:src="item.image")
                    .container
                        Editor(:contents="item.editor")
            .controls(v-if="items.length > 1")
                button.left(@click="toggleBanner(-1)" :disabled="ativo <= 0")
                    FontAwesomeIcon(:icon="icons.faChevronLeft")
                button.right(@click="toggleBanner(1)" :disabled="ativo == items.length - 1")
                    FontAwesomeIcon(:icon="icons.faChevronRight")
</template>

<script>
import { props } from '@/mixins/component'
import Editor from '@sections/Pagina/Editor/Editor'

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "section-depoimentos",
    props,
    components: {
        Editor,
    },
    data() {
        return {
            // items: [],
            icons: {
                faChevronLeft, faChevronRight
            },
            ativo: 0,
        }
    },
    computed: {
        items() {
            return this.contents.content.map(item => ({
                ...item,
                image: item.image,
                editor: {content: item.editor}
            }))
        }
    },
    methods: {
        toggleBanner(amount){
            const gallery = document.getElementById('galeria')
            this.ativo += amount
            gallery.style.transform = `translateX(-${this.ativo * 100}%`
        }
    }
}
</script>

<style lang="stylus" scoped src="./CareerCasesSection.styl"></style>
